import actions from './actions';

const {
  GET_ALL_SETTINGS_BEGIN,
  GET_ALL_SETTINGS_ERR,
  GET_ALL_SETTINGS_SUCCESS,

  GET_ALL_COUNTRIES_BEGIN,
  GET_ALL_COUNTRIES_ERR,
  GET_ALL_COUNTRIES_SUCCESS,

  RESET_SINGLE_SETTING_DATA,

  GET_SINGLE_SETTING_BEGIN,
  GET_SINGLE_SETTING_ERR,
  GET_SINGLE_SETTING_SUCCESS,

  EDIT_SETTING_BEGIN,
  EDIT_SETTING_ERR,
  EDIT_SETTING_SUCCESS,

  ADD_SETTING_BEGIN,
  ADD_SETTING_ERR,
  ADD_SETTING_SUCCESS,
} = actions;

const initialStateSingleSetting = {
  data: null,
  loading: false,
  error: null,
  editSetting: {
    loading: false,
    error: false,
    data: null,
  },
  countries: {
    loading: false,
    error: false,
    data: null,
  },
};

const initialStateAllSettings = {
  data: [],
  loading: false,
  error: null,
};

const settingsReducer = (state = initialStateAllSettings, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ALL_SETTINGS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_SETTINGS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_ALL_SETTINGS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singleSettingReducer = (state = initialStateSingleSetting, action) => {
  const { type, data, err } = action;
  switch (type) {
    case RESET_SINGLE_SETTING_DATA:
      return initialStateSingleSetting;
    case GET_SINGLE_SETTING_BEGIN:
      return {
        ...state,
        editSetting: {
          loading: false,
          error: null,
          data: null,
        },
        loading: true,
      };
    case GET_SINGLE_SETTING_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_SINGLE_SETTING_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_ALL_COUNTRIES_BEGIN:
      return {
        ...state,
        countries: {
          loading: false,
          error: null,
          data: null,
        },
      };
    case GET_ALL_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          data,
          error: null,
          loading: false,
        },
      };
    case GET_ALL_COUNTRIES_ERR:
      return {
        ...state,
        countries: {
          data: null,
          error: err,
          loading: false,
        },
      };
    case ADD_SETTING_BEGIN:
      return {
        ...state,
        loading: true,
        editSetting: {
          data: null,
          loading: true,
          error: err,
        },
      };
    case ADD_SETTING_SUCCESS:
      return {
        ...state,
        editSetting: {
          data,
          loading: false,
          error: null,
        },
      };
    case ADD_SETTING_ERR:
      return {
        ...state,
        editSetting: {
          data: null,
          loading: false,
          error: err,
        },
      };
    case EDIT_SETTING_BEGIN:
      return {
        ...state,
        editSetting: {
          ...state.editSetting,
          loading: true,
        },
      };
    case EDIT_SETTING_SUCCESS:
      return {
        ...state,
        editSetting: {
          ...state.editSetting,
          data,
          loading: false,
          error: null,
        },
      };
    case EDIT_SETTING_ERR:
      return {
        ...state,
        editSetting: {
          ...state.editSetting,
          loading: false,
          error: err,
        },
      };
    default:
      return state;
  }
};

export { singleSettingReducer, settingsReducer };
